export interface MoneyTransferRequestDetails {
	sourceCustomerEmail?: string;
	sourceCustomerName: string;
	sourceCustomerAccount: string;
	sourceCustomerCurrency: string;
	beneficiaryCustomerAccount: string;
	beneficiaryCustomerEmail?: string;
	beneficiaryCustomerCurrency?: string;
	transactionAmount: string;
	paymentNotes: string;
	transactionFee?: number;
	beneficiaryName: string;
	sourceCurrentBalance: number;
	transferId?: number;
}

export interface WithdrawToAnyIBANMoneyTransferRequestDetails {
	sourceCustomerAccount: string;
	sourceCustomerName: string;
	sourceCustomerCurrency: string;
	beneficiaryCustomerAccount: string;
	beneficiaryCustomerBankName: string;
	beneficiaryCustomerCurrency: string;
	beneficiaryCustomerName: string;
	transactionAmount: number;
	paymentNotes: string;
	transactionFee: number;
	sourceCurrentBalance: number;
	transferId: number;
}

export interface WithdrawToAnyIBANMoneyTransferRequest {
	sourceCustomerAccount: string;
	beneficiaryCustomerAccount: string;
	beneficiaryCustomerName: string;
	amount: number;
	notes?: string;
	currency: string;
}

export interface BankTransferRequestModel {
	sourceEntityType: TennEntityType;
	sourceEntityId: number;
	transferId: number;
}

export interface BankTransferInitiateRequestModel {
	transferType: TransferType;
	requestChannel: ServiceClients;
	sourceEntityType: TennEntityType;
	sourceEntityId: number;
	sourceCustomerIban: string;
	beneficiaryEntityType: TennEntityType;
	beneficiaryEntityId: number
	beneficiaryCustomerIban: string;
	beneficiaryCustomerBic: string;
	beneficiaryCustomerName: string;
	amount: number;
	paymentNotes: string;
	network: string;
	// currency: string;
}

export interface BankTransferInitiateResultModel {
	sourceEntityType: TennEntityType;
	sourceEntityId: number;
	transferId: number;
	responseCode: BankTransferResponseCode;
	chargeAmount: number;
	chargeCurrency: string;
}

export interface BankTransferResultModel {
	sourceEntityType: TennEntityType;
	sourceEntityId: number;
	transferId: number;
	responseCode: BankTransferResponseCode;
	transactionId: string;
}

export enum TransferType {
	ThirdPartyTransfer = 'ThirdPartyTransfer',
	Withdrawal = 'Withdrawal',
	P2P = 'P2P',
}

export enum ServiceClients {
	WalletApp10n = 'WalletApp10n',
	OpenBanking = 'OpenBanking',
	MerchantPayment = 'MerchantPayment',
}

export enum NetworkType {
	Bulk = 'BISERA',
	Instant = 'INST',
	Virement = 'VIREMENT',
	Internal = 'INTERNAL'
}

export enum TennEntityType {
	Unknown = 0,
	Individual = 1,
	Merchant = 2
}



export enum BankTransferResponseCode {
	OK = 0,
	RiskReject = 1,
	SourceOfFundsRequired = 2,
	UnderReiew = 3
}

export interface PointToPointMoneyTransferRequestModel {
	sourceCustomerAccount: string;
	beneficiaryCustomerAccount: string;
	transactionAmount: number;
	paymentNotes?: string;
}

export interface CalculateMoneyTransferChargeRequest {
	customerAccount: string;
	amount: number;
	id: number;
	PaymentType: string;
}

export interface DepositMoneyFromExistingCardPaymentMethodUserRequest {
    transactionAmount: number;
    transactionCharge: number;
    paymentMethodId: string;
    transactionCurrency: string;
    accountNumber: string;
    deviceIP: string;
}

export interface CardOperationInitiateResponse {
	data: string ;
	redirectUrl: string ;
}

export const PaymentType = {
	P2P: "P2P",
	P2IbanWithdrawal: "P2IbanWithdrawal",
	P2IBAN: "P2IBAN",
	DepositFromMasterCard: "DepositFromMasterCard",
	DepositFromVisaCard: "DepositFromVisaCard",
	DepositFromOtherCard: "DepositFromOtherCard",
	WithdrawalMasterCard: "WithdrawalMasterCard",
	withdrawalVisaCard: "WithdrawalVisaCard",
	WithdrawalOtherCard: "WithdrawalOtherCard"
};


export interface PointToPointMoneyTransferRequestModel {
	sourceCustomerAccount: string;
	beneficiaryCustomerAccount: string;
	transactionAmount: number;
	paymentNotes?: string;
}


export interface ValidateIbanRequest {
	iban: string;
}

export interface ValidateIbanResponse {
	iban: string;
	bic: string;
	bank: string;
	branch?: string;
	country?: string;
	city?: string;
	state?: string;
	zip?: string;
	address?: string;
	account?: string;
	timeStamp: Date;
}

export interface CalculateMoneyTransferChargeRequest {
	customerAccount: string;
	amount: number;
	id: number;
	PaymentType: string;
}

export interface MoneyTransferChargeResponse {
	accountNo: string;
	accountBalance: number;
	accountCurrency: string;
	transactionAmount: number;
	transactionCurrency: string;
	transactionFee: number;
	transactionFeeCurrency: string;
}

export enum PaymentMethodStatus {
	Approve = "1",
	UnderReview = "2",
	Reject = "3"
}

export const PaymentMethodType = {
	Card: "card",
	Bank: "bank",
	NonIBAN: "non-iban"
}